export default __webpack_public_path__ + "static/media/as-if-its-your-last.6463ed69.jpg";